import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';
declare let $: any;
declare let Swal: any;

@Component({
    selector : 'iframe-screen',
    templateUrl:'iframe-screen.html'
})
export class IframeScreenComponent implements OnInit, OnDestroy{

  public frame="https://liveoffice.com.br/checklist?uid=T6sKpIAzwlPlYmEGgy2FuolQ2wN2&chk=Treinamento%20Manaus%2001&idx=1";
  public name="";
  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    if (this._appData.param){
      this.frame=this._appData.param;
      this._appData.param=null;
    }
  }
  public ngOnDestroy() : any {
  }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/iframe-screen/iframe-screen.ts